/**
 * @generated SignedSource<<f72616529558e13eb1fbbe15f98dce07>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAIVirtualModelRulePanel_AssignProductMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type addAIVirtualModelRulePanel_AssignProductMutation$data = {
  readonly assignProductsToAIVirtualModelRule: {
    readonly result: boolean;
  };
};
export type addAIVirtualModelRulePanel_AssignProductMutation = {
  response: addAIVirtualModelRulePanel_AssignProductMutation$data;
  variables: addAIVirtualModelRulePanel_AssignProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToAIVirtualModelRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "addAIVirtualModelRulePanel_AssignProductMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "addAIVirtualModelRulePanel_AssignProductMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "9f12c2ecb7cbbcc6d995c8655240236a",
    "id": null,
    "metadata": {},
    "name": "addAIVirtualModelRulePanel_AssignProductMutation",
    "operationKind": "mutation",
    "text": "mutation addAIVirtualModelRulePanel_AssignProductMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToAIVirtualModelRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c9f9cd40d9910ca66ccb2341cdff595";

export default node;
